import React from 'react'
import { Typography } from 'transfix-ui/core'
import CarrierTrailerRowContainer, {
  TrailerNumberContainer,
  StopTypeContainer,
  NextAppointmentContainer,
  LaneContainer,
  ShipmentContainer,
  LocationContainer,
} from './CarrierTrailerRowContainer'

const CarrierTrailerHeader = () => {
  return (
    <CarrierTrailerRowContainer>
      <TrailerNumberContainer>
        <Typography variant='subtitle2' color='textSecondary'>
          Trailer #
        </Typography>
      </TrailerNumberContainer>
      <StopTypeContainer>
        <Typography variant='subtitle2' color='textSecondary'>
          Stop Type
        </Typography>
      </StopTypeContainer>
      <NextAppointmentContainer>
        <Typography variant='subtitle2' color='textSecondary'>
          Next Appointment
        </Typography>
      </NextAppointmentContainer>
      <LaneContainer>
        <Typography variant='subtitle2' color='textSecondary'>
          Lane
        </Typography>
      </LaneContainer>
      <ShipmentContainer>
        <Typography variant='subtitle2' color='textSecondary'>
          Shipment
        </Typography>
      </ShipmentContainer>
      <LocationContainer>
        <Typography variant='subtitle2' color='textSecondary'>
          Location
        </Typography>
      </LocationContainer>
    </CarrierTrailerRowContainer>
  )
}

export default CarrierTrailerHeader
